import { Injectable } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  constructor(private config: ConfigService) {}

  isEnabled(flag: string): boolean {
    const flags = this.config.get('featureFlags') || {};
    return !!flags[flag];
  }
}
